// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3UONZ","inputWrap":"Table_inputWrap__2MIOS","col":"Table_col__74FmH","bmiTooltip":"Table_bmiTooltip__3TTMY"};